import Vue from 'vue'

import { INTERVALS_AVAILABLE_ORDER_TYPES } from '@/constants/orderTypes'
import { $themeConfig } from '@themeConfig'

const DELIVERY_INTERVALS_API_URL = `${$themeConfig.app.backUrlDeliveryApiV2}/intervals`

export function fetchIntervals(payload, type) {
    if (!type) {
        throw new Error(
            'fetchIntervals: обязателен тип заказа для получения интервалов'
        )
    }

    if (!INTERVALS_AVAILABLE_ORDER_TYPES.includes(type)) {
        throw new Error(
            'fetchIntervals: неизвестный тип заказа для получения интервалов'
        )
    }

    return Vue.axios.post(`${DELIVERY_INTERVALS_API_URL}/${type}`, payload)
}
